import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UseAuth from "../../pages/Authentication/Auth";
import { useNavigate, useLocation, useParams, useSearchParams, Link } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { LoginService } from "../../API/loginApi";

const MemberLogIn = (props) => {
  let searchParams = useSearchParams();
  const [disabled, setDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const formId = "599673a925f548d7dbbd7c86";
  const authkey = localStorage.getItem("_authkey");
  const companyName = localStorage.getItem("branchname");
  const iframeRef = useRef(null);
  const [previousURL, setPreviousURL] = useState("");
  const previousPathRef = useRef(null);
  const auth = UseAuth();
  const location = useLocation();
  let params = useParams();
  let previousState = location.state?.previouspath;
  let previousdata = location.state?.previousPathState?.selecteddetail;
  const navigate = useNavigate();

  const validateForm = (data) => {
    const errors = {};
    if (!data.email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "Email is not valid";
    }
    if (!data.password) {
      errors.password = "Password is required";
    } else if (data.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }
    return errors;
  };

  useEffect(() => {
    previousPathRef.current = location.pathname; // Update previous path
  }, [location]);

  const previousPath = previousPathRef.current; // Access previous path
  console.log("previousPath::: ", previousPath);

  useEffect(() => {
    const referrer = document.referrer;
    setPreviousURL(referrer || "No referrer available");
  }, []);

  const memberFormSubmit = async (data) => {
    const validationErrors = validateForm(data);
    if (Object.keys(validationErrors).length > 0) {
      Object.entries(validationErrors).forEach(([key, message]) => {
        toast.error(message, { autoClose: 1500 });
      });
      return;
    }

    setDisabled(true);
    setIsLoading(true);
    try {
      const loginObj = await LogInUser(data);

      if (
        loginObj.status === 200 &&
        loginObj.data?.error === undefined &&
        loginObj.data?.user?.status === "active"
      ) {
        toast.success(
          "Login Successfully",
          { autoClose: 1500 },
          { backgroundColor: "green" }
        );
        localStorage.setItem("Locale", loginObj.data.user.branchid.locale); // locale
        localStorage.setItem("Currency", loginObj.data.user.branchid.currency); // currency
        localStorage.setItem("LoginUserId", loginObj.data.user._id);
        localStorage.setItem("LoginUserType", loginObj.data.usertype ? loginObj.data.usertype : "Member");
        localStorage.setItem("UserToken", loginObj.data.token);
        localStorage.setItem("LoginUserName", loginObj.data.user.fullname);
        localStorage.setItem("data", JSON.stringify(loginObj.data));
        localStorage.setItem(
          "LoginAuth",
          window.location.pathname.split("/")[1] + "_" + loginObj.data.token
        );
        if (auth && typeof auth.Login === "function") {
          auth.Login(loginObj.data);
        } else {
          console.error("Auth object is null or Login method is not defined.");
        }
        if (previousState !== undefined) {
          navigate(
            previousState,
            {
              state: {
                data: previousdata,
                backgroundcolor: params?.backgroundcolor,
                foregroundcolor: params?.foregroundcolor,
              },
            },
            { replace: true }
          );
        } else if (props.redirectUrl !== undefined) {
          props.loadBuyer(loginObj.data.user._id);
        } else {
          navigate("/" + companyName);
        }
      } else {
        toast.error(
          loginObj.data?.user?.status !== "active"
            ? "Invalid login credentials"
            : loginObj.data.error,
          { autoClose: 1000 },
          { backgroundColor: "red" }
        );
      }
    } catch (error) {
      console.error("An error occurred during login:", error);
      toast.error("An error occurred during login. Please try again.", {
        autoClose: 1000,
      });
    } finally {
      setIsLoading(false);
      setDisabled(false);
    }
  };

  const LogInUser = async (loginData) => {
    let payload = {
      username: loginData.email,
      password: loginData.password,
    };
    return LoginService(payload);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      {isLoading && <Spinner />}

      <form
        className="membroz-form login_form_inside_input"
        onSubmit={(e) => {
          e.preventDefault();
          const formData = new FormData(e.target);
          const data = Object.fromEntries(formData.entries());
          memberFormSubmit(data);
        }}
      >
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Password</label>
          <div className="password-wrapper" style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Password"
              className="form-control"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showPassword ? (
                <i className="fa fa-eye-slash" aria-hidden="true"></i>
              ) : (
                <i className="fa fa-eye" aria-hidden="true"></i>
              )}
            </button>
          </div>
        </div>
        <div className="form-group mt-3">
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-block"
            disabled={disabled}
          >
            Sign In
          </button>
        </div>
              <br/>
        {/* <p className="text-center">
          Don't have an account ? */}
          {/* <Link
            className="hover_signup_text"
            to={"/" + companyName + "/sign-up"}
          >
            &nbsp; Sign Up
          </Link> */}
        {/* </p> */}
      </form>
    </>
  );
};

export default MemberLogIn;
